import './Soldier.css';
import soldierImg from '../../../../images/Soldier.png';

export const Soldier = () => {
    return (
        <div className="soldier">
            <img src={soldierImg} alt="" className="soldier__img" />
            <span className="soldier__name">soldier csgetto.cash</span>
            <span className="soldier__number">145</span>
        </div>
    );
};
